import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface ContactCandidate {
  user_id: string;
  full_name: string;
  email: string | null;
  phone: string | null;
  role: string;
  is_self: boolean;
}

const cache = new Map<string, ContactCandidate[]>();

export function useCompanyContactCandidates(companyId: string | null | undefined) {
  const [candidates, setCandidates] = useState<ContactCandidate[]>(() =>
    companyId ? cache.get(companyId) || [] : []
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!companyId) return;
    const cached = cache.get(companyId);
    if (cached) {
      setCandidates(cached);
      return;
    }
    let cancelled = false;
    setLoading(true);
    supabase
      .rpc('get_company_contact_candidates', { p_company_id: companyId } as never)
      .then(({ data, error: err }) => {
        if (cancelled) return;
        if (err) {
          setError(err.message);
          setCandidates([]);
        } else {
          const list = (data as ContactCandidate[]) || [];
          cache.set(companyId, list);
          setCandidates(list);
        }
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [companyId]);

  return { candidates, loading, error };
}